import { Dosing, enforceProtocolWithDosingsTypes } from "@protoplan/types";
import { axiosInstance } from "./axiosInstance";

interface Supp
{
  suppId: number,
  suppName: string | null,
}

export interface MmProtocolDosing extends Supp, Dosing
{
  mmProtocolDosingId: number,
  doseUnit: string,
  priority: number
};


export interface MmProtocolInfo
{
  mmProtocolId: number,
  name: string,
  bookId: number,
  bookTitle: string
}

export interface MmProtocol extends MmProtocolInfo
{
  dosings: MmProtocolDosing[]
}

export async function searchMmProtocols(query: string)
{
  return axiosInstance.post("/mmProtocol/search", { query })
    .then(resJson => resJson.data as MmProtocolInfo[])
    .catch(error => console.log("Error searching MM protocols:", error));
}

export async function getMmProtocol(mmProtocolId: number)
{
  return axiosInstance.post("/mmProtocol/protocol", { mmProtocolId })
    .then(resJson => resJson.data as MmProtocolInfo | undefined)
    .catch(error => console.log("Error retrieving MM protocol:", error));
}

export async function getMmProtocols()
{
  return axiosInstance.post("/mmProtocol/protocols")
    .then(resJson => resJson.data as MmProtocolInfo[])
    .catch(error => console.log("Error retrieving MM protocols:", error));
}

export async function getMmProtocolDosings(mmProtocolId: number)
{
  return axiosInstance.post("/mmProtocol/dosings", { mmProtocolId })
    .then(resJson => (resJson.data as MmProtocolDosing[]).map(d => ({
      ...d,
      daysPerMonth: Number(d.daysPerMonth),
      dosesPerDay: Number(d.dosesPerDay),
      dose: Number(d.dose) })))
    .catch(error => console.log("Error retrieving MM protocol dosings:", error));
}

export async function postDuplicate(mmProtocolId: number)
{
  return axiosInstance.post("/mmProtocol/duplicate", { mmProtocolId })
    .then(res => enforceProtocolWithDosingsTypes(res.data))
    .catch(error => console.log("Error dupliacting MM protocol " + mmProtocolId + ":", error));
}
